<script>
  import ScaleEditor from "./scaleEditor.svelte";
  import ItemResponse from "./ItemResponse.svelte";

  export let field, closer, updateRCField, role;
  export let currEncType,
    currEncDataType,
    currEncSort,
    currBin,
    currBinCount,
    currAggregate,
    currEncScaleType,
    currEncFieldType,
    inputFocusAction,
    inputBlurAction;
</script>

<h3 class="with-close-button" style="position: sticky-top;">
  <div>Edit field for {role}</div>
  <div
    on:click={() => {
      closer();
    }}
  >
    <i class="bi bi-x" />
  </div>
</h3>
<!-- title -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="text"
    token="field"
    title="Field"
    readonly={true}
    {inputFocusAction}
    {inputBlurAction}
    value={field.field || ""}
  />
</div>
<!-- stack method -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="select"
    token="stack"
    title="Stack method"
    options={[null, "center", "normalize", "none"]}
    optionNames={["Zero (Default)", "Center", "Normalize", "No stacking"]}
    {inputFocusAction}
    {inputBlurAction}
    value={field.stack || null}
    changeAction={(event) => {
      updateRCField(event, "position", "encoding.stack");
    }}
  />
</div>
<!-- scale -->
<ScaleEditor
  currField={field}
  {currEncType}
  {currEncDataType}
  {currEncSort}
  {currBin}
  {currBinCount}
  {currAggregate}
  currentEncoding="position"
  rcRole={role}
  {inputFocusAction}
  {inputBlurAction}
  updateEncoding={updateRCField}
  {currEncFieldType}
  {currEncScaleType}
/>
<!-- lock -->
<div class="pane-divider" />
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="lock"
    tooltipMessage="Prevent suggesting responsive alternatives that make changes to this channel. Element-Lock applies to its source or target design(s)."
    title="Lock this channel"
    token={"rc-lock-" + role}
    value={field.lock}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateRCField(event, "lock", role);
    }}
  />
</div>